import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const card: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  boxShadow: 'none',
  padding: (p) => p.spacing(2),
  borderColor: (p) => p.palette.grey[400],
};
